import React, { useEffect, useState } from 'react';
import TrainingService from '../../Service/TrainingService';

const fundingTypes = [
    "A titre individuel",
    "Par l’employeur",
    "Par France Travail",
    "Par le CPF",
    "Par OPCO",
    "Par FIF-PL",
    "Par AGEFIPH",
    "Par Fond solidaire PSSM France"
];

const TrainingPrice = ({ training }) => {
    const [editMode, setEditMode] = useState(false);
    const [individualPrice, setIndividualPrice] = useState('');
    const [groupOffer, setGroupOffer] = useState('');
    const [cpfLink, setCpfLink] = useState('');
    const [fundingOptions, setFundingOptions] = useState([]);
    const token = sessionStorage.getItem('token');

    useEffect(() => {
        if (training.cost) {
            setIndividualPrice(training.cost);
        }
        setGroupOffer(training.prixMax || '');

        // Traitement du champ cpf (string simple ou JSON)
        try {
            const parsedCpf = JSON.parse(training.cpf);
            setFundingOptions(parsedCpf.options || []);
            setCpfLink(parsedCpf.link || '');
        } catch {
            // Ancien format (juste un lien CPF)
            setFundingOptions(training.cpf ? ["Par le CPF"] : []);
            setCpfLink(training.cpf || '');
        }
    }, [training]);

    const handleCheckboxChange = (type) => {
        if (fundingOptions.includes(type)) {
            setFundingOptions(fundingOptions.filter(f => f !== type));
        } else {
            setFundingOptions([...fundingOptions, type]);
        }
    };

    const handleSaveClick = async () => {
        training.cost = individualPrice;
        training.prixMax = groupOffer !== '' ? groupOffer : null;
        training.cpf = JSON.stringify({
            link: fundingOptions.includes("Par le CPF") ? cpfLink : '',
            options: fundingOptions
        });

        try {
            const response = training.modif
                ? await TrainingService.putModifTraining(training)
                : await TrainingService.postModifTraining(training);
            console.log(response);
        } catch (error) {
            console.log("Error: " + error);
        }

        window.location.reload();
        setEditMode(false);
    };

    return (
        <div className="section-content">
            {editMode ? (
                <div>
                    <label>Prix individuel:</label>
                    <input
                        type="number"
                        value={individualPrice}
                        onChange={(e) => setIndividualPrice(e.target.value)}
                        style={{ width: '100%' }}
                    />

                    <label>Prix de groupe:</label>
                    <input
                        type="number"
                        value={groupOffer}
                        onChange={(e) => setGroupOffer(e.target.value)}
                        style={{ width: '100%' }}
                    />

                    <label>Types de financement :</label>
                    {fundingTypes.map((type) => (
                        <div key={type}>
                            <label style={{ cursor: 'pointer' }}>
                                <input
                                    type="checkbox"
                                    checked={fundingOptions.includes(type)}
                                    onChange={() => handleCheckboxChange(type)}
                                    style={{ marginRight: '8px' }}
                                />
                                {type}
                            </label>
                            {type === "Par le CPF" && fundingOptions.includes("Par le CPF") && (
                                <input
                                    type="text"
                                    value={cpfLink}
                                    onChange={(e) => setCpfLink(e.target.value)}
                                    placeholder="Lien CPF"
                                    style={{ marginLeft: '10px', width: '70%' }}
                                />
                            )}
                        </div>
                    ))}
                </div>
            ) : (
                <div>
                    {training.cost && (
                        <p>Le tarif individuel est de {individualPrice}€ par personne.</p>
                    )}
                    {training.prixMax ? (
                        <p>Le tarif de groupe est de {groupOffer}€.</p>
                    ) : (
                        <p>Offres personnalisées selon les groupes.</p>
                    )}

                    {(() => {
                        let parsed = { link: '', options: [] };
                        try {
                            if (training.cpf) {
                                const json = JSON.parse(training.cpf);
                                parsed = {
                                    link: json?.link || '',
                                    options: Array.isArray(json?.options) ? json.options : []
                                };
                            }
                        } catch {
                            if (typeof training.cpf === 'string' && training.cpf.trim() !== '') {
                                parsed = { link: training.cpf, options: ["Par le CPF"] };
                            }
                        }

                        return parsed.options.length > 0 ? (
                            <div style={{ listStyleType: 'disc'}}>
                                <p>Financements disponibles :</p>
                                <ul style={{ marginLeft: '2rem' }}>
                                    {parsed.options.map((option) => (
                                        <li key={option}>
                                            {option}
                                            {option === "Par le CPF" && parsed.link && (
                                                <> : <a href={parsed.link}>{parsed.link}</a></>
                                            )}
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        ) : null;
                    })()}
                </div>
            )}

            {editMode ? (
                <button
                    className="inscription-button modif_button"
                    onClick={handleSaveClick}
                    style={{ right: 0 }}
                >
                    Enregistrer
                </button>
            ) : (
                token === '' && (
                    <button
                        className="inscription-button modif_button"
                        onClick={() => setEditMode(true)}
                        style={{ marginLeft: '10px' }}
                    >
                        Modifier
                    </button>
                )
            )}
        </div>
    );
};

export default TrainingPrice;